// Direct import to avoid circular dependency through the components barrel
import { AppSkeleton } from '../AppSkeleton';
import { spacing } from '@/theme/tokens';

/** Approximate height of a rendered AssistantFeedCard, used to prevent layout shift */
export const FEED_CARD_HEIGHT = 156;

export function AssistantFeedSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: spacing[3] }}>
      {[0, 1, 2].map((i) => (
        <AppSkeleton key={i} height={FEED_CARD_HEIGHT} />
      ))}
    </div>
  );
}
